import { Loader } from 'gocclr-shared-ui/dist/elements/loader/loader';
import React from 'react';
import styled from 'styled-components';

const Splashscreen = styled(Loader)`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
`;

export const SafeSuspense: React.FunctionComponent = ({ children }) => (
    <React.Suspense fallback={<Splashscreen />}>
        {children}
    </React.Suspense>
);